import Modal from "components/Modal";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import { SocialHandlesProps } from "pages/AgencyInformation/components/ContactCard";
import SocialHandle from "pages/AgencyInformation/components/SocialHandle";
import { MileStone, MileStoneIcon } from "pages/Profile/HighLight/HighLight.styled";
import { useHighLight } from "pages/Profile/HighLight/useHighLight";
import { FC, useEffect, useState } from "react";
import { BsInstagram, BsLink } from "react-icons/bs";
import { FaFacebookSquare, FaTwitterSquare } from "react-icons/fa";
import { HiBadgeCheck } from "react-icons/hi";
import { useAppSelector } from "slice";
import theme from "theme";
import {
    BottomRow,
    DetailSection,
    FlexBetween,
    InstagramIcon,
    ListItem,
    ListSection,
    Name,
    ProfileHighlight,
    ShareIcon,
    ShareIcons,
    UserNameSection
} from "./CompanyCard.styled";
import ImageSection from "./HighLight/ImageSection";
const CompanyCard: FC = () => {
    const { isModalOpen, availabilityStatus, toggleModal, handleChange } =
        useHighLight();
        const {data: {attributes:{ user_type, experiences, first_name, last_name, social_links, is_verified}} } = useAppSelector(
            (state) => state.model
        );
    const [socialHandles, setSocialHandles] = useState<SocialHandlesProps>(Array<{
        id: string;
        username: string;
        user_id: string;
        created_at: string;
        updated_at: string;
        social_platforms_id: number;
    }>);

    useEffect(() => {
        if (social_links) {
            const socialLinks = [ ...social_links ];
            setSocialHandles(socialLinks);
        }
    }, [social_links]);
    return (
        <ProfileHighlight>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <Modal.Header>
                    <Text variant="heading3">Share</Text>
                </Modal.Header>
                <Modal.Content>
                    <ShareIcons>
                        <ShareIcon>
                            <BsInstagram />
                            <Text variant="label">Instagram</Text>
                        </ShareIcon>
                        <ShareIcon>
                            <FaFacebookSquare />
                            <Text variant="label">Facebook</Text>
                        </ShareIcon>
                        <ShareIcon>
                            <FaTwitterSquare />
                            <Text variant="label">Twitter</Text>
                        </ShareIcon>
                        <ShareIcon>
                            <BsLink />
                            <Text variant="label">Copy Link</Text>
                        </ShareIcon>
                    </ShareIcons>
                </Modal.Content>
            </Modal>
            <ImageSection />
            <DetailSection>
                <InstagramIcon>
                    <SocialHandle socialHandles={socialHandles} />
                </InstagramIcon>
                <FlexBetween>
                    <UserNameSection>
                    <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <Name variant="heading2">
                            {first_name} {last_name}
                            </Name>
                            {/* <ProBadge src={ProBadgeImage} alt="Pro Badge Image" /> */}
                            <Text
                                variant="body2"
                                color={theme.colors.grey.dark}
                                style={{
                                    display: "flex", // Enable flexbox
                                    alignItems: "center", // Vertically align items
                                    justifyContent: "space-between", // Space items if needed
                                    gap: "10px", // Add spacing between items
                                }}
                            >
                                {is_verified && (
                                    <MileStone
                                        left={"0"}
                                        isVerifiedMileStone={false}
                                        isComplete={false}
                                    >
                                        <MileStoneIcon>
                                            <HiBadgeCheck />
                                        </MileStoneIcon>
                                    </MileStone>
                                )}
                            </Text>
                        </div>
                        
                    </UserNameSection>
                    
                </FlexBetween>
                <BottomRow>
                    <SingleSelect
                        label=""
                        value={availabilityStatus}
                        options={[
                            {
                                value: "Available",
                                label: "Available to work",
                                selected: true,
                            },
                            {
                                value: "Unavailable",
                                label: "unavailable to work",
                            },
                        ]}
                        onChange={handleChange}
                    />

                    {experiences && (
                        <ListSection>
                            <ListItem>
                                <Text
                                    variant="label"
                                    color={theme.colors.grey.primary}
                                    fontWeight="500"
                                >
                                    Type
                                </Text>
                                <Text variant="label" fontWeight="500">
                                    {user_type}
                                </Text>
                            </ListItem>
                            <ListItem>
                                <Text
                                    variant="label"
                                    color={theme.colors.grey.primary}
                                    fontWeight="500"
                                >
                                    Experience
                                </Text>
                                <Text variant="label" fontWeight="500">
                                    4 years
                                </Text>
                            </ListItem>
                        </ListSection>
                    )}
                </BottomRow>
            </DetailSection>
        </ProfileHighlight>
    );
};

export default CompanyCard;
